import type { GuitarTrackAnalysis, ToneScene } from '../../models/toneAnalysis'
import { formatDuration, formatEnum, formatPercent, formatTimeSpan } from '../../utils/toneAnalysisFormat'

type GuitarTrackCardProps = {
  track: GuitarTrackAnalysis
  toneScenes: ToneScene[]
}

export function GuitarTrackCard({ track, toneScenes }: GuitarTrackCardProps) {
  const orderedSections = [...track.sections].sort((left, right) => left.start.localeCompare(right.start))

  return <article className="ts-analysis-card">
    <div className="ts-analysis-card-head">
      <div>
        <span>{formatEnum(track.role)}</span>
        <h4>Layer {track.layerIndex + 1}</h4>
      </div>
      <b>{formatPercent(track.confidence)}</b>
    </div>
    <ul className="ts-analysis-section-list">
      {orderedSections.map((section) => {
        const scene = toneScenes.find((toneScene) => toneScene.id === section.toneSceneId)

        return <li key={section.id}>
          <div>
            <b>{section.musicalSection ?? 'Detected section'}</b>
            <span>{formatTimeSpan(section.start)} - {formatTimeSpan(section.end)} - {formatDuration(section.start, section.end)}</span>
          </div>
          <div>
            <strong>{scene?.suggestedName ?? 'Tone scene'}</strong>
            <span>{formatPercent(section.confidence)}</span>
          </div>
        </li>
      })}
    </ul>
  </article>
}
